// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2ErEU","content":"ManualTimeModal_content__3A9mR"};